import {
  Form,
  FormButton,
  SwitchInput,
  useNotifications
} from '@ijoin/components';
import {
  getGetPlanQueryKey,
  useGetPlanSuspense,
  usePatchPlan
} from '@ijoin/hooks';
import { Divider, Stack, Typography } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';

import { FC } from 'react';
import { useForm } from 'react-hook-form';

type SettingsFormProps = {
  isDemo: boolean;
};

export const PlanSettingsTab: FC<{ planId: string }> = props => {
  const queryClient = useQueryClient();
  const notifications = useNotifications();

  const plan = useGetPlanSuspense(props.planId);

  const methods = useForm<SettingsFormProps>({
    mode: 'all',
    values: { isDemo: plan.data.isDemo ?? false }
  });

  const patchPlan = usePatchPlan({
    mutation: {
      onError: () => notifications.error('Failed to update plan settings'),
      onSuccess: () => {
        notifications.success('Plan settings updated successfully');
        queryClient.invalidateQueries({
          queryKey: getGetPlanQueryKey(props.planId)
        });
      }
    }
  });

  const onSubmit = (data: SettingsFormProps) => {
    patchPlan.mutate({
      data: {
        isDemo: data.isDemo
      },
      planId: props.planId
    });
  };

  return (
    <Form
      data-testid='planSettingsForm'
      methods={methods}
      noValidate
      onSubmit={methods.handleSubmit(onSubmit)}>
      <Stack
        pt={2}
        spacing={2}
        sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
        <Typography color='text.secondary' variant='h6'>
          Plan Type
        </Typography>
        <Divider />
        <SwitchInput
          color='success'
          data-testid='isDemo'
          hideError
          label='Demo Plan'
          name='isDemo'
        />

        <FormButton
          data-testid='savePlanSettings'
          sx={{ alignSelf: 'flex-start' }}
          triggerValidation
          variant='contained'>
          Save
        </FormButton>
      </Stack>
    </Form>
  );
};

PlanSettingsTab.displayName = 'PlanSettingsTab';
